<mat-card class="example-card">
  <mat-card-header class="titreFrm">
    <mat-card-title
      >LISTE R&Eacute;SERVATIONS &Eacute;QUIPEMENTS</mat-card-title
    >
  </mat-card-header>
  <mat-card-content class="border">
    <!------------ bare de chargement ----------------->
    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <mat-card>
      <mat-card-content>
        <div class="displayFlex">
          <div class="width-250">
            <mat-form-field appearance="outline" class="width-250">
              <mat-label>Collaborateurs</mat-label>
              <mat-select
                placeholder="Collaborateurs"
                [(ngModel)]="selectedPerso_Matricule"
                (selectionChange)="afficherListeReservation()"
              >
                <mat-option
                  *ngFor="let Perso of listeCollaborateurs"
                  [(ngModel)]="Perso.Perso_Matricule"
                  >{{ Perso.Perso_Nom }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <button
              (click)="goToReservationMachine('MODE_AJOUT')"
              [disabled]="!exist"
              mat-raised-button
              class="colorGreen"
            >
              <mat-icon>add</mat-icon>Ajouter
            </button>
            <!-- <button *ngIf="fenetre == '0'" (click)="goToReservationMachine('MODE_MODIFIER')" [disabled]="!exist" mat-raised-button class="colorBlue"><mat-icon>edit</mat-icon>Modifier</button> -->
            <button
              *ngIf="fenetre == '0'"
              (click)="supprimer()"
              [disabled]="!exist"
              class="colorRed"
              mat-raised-button
            >
              <mat-icon>delete</mat-icon>Supprimer
            </button>
          </div>
        </div>
        <app-avt-listes
          #listeReservationComponen
          [heightTable]="'400'"
          [displayedColumnsBrut]="columns"
        >
        </app-avt-listes>
      </mat-card-content>
    </mat-card>
  </mat-card-content>
</mat-card>
